var exports = {
  "JC": "UserProfilePopout.module__role___S1lyQm",
  "s$": "UserProfilePopout.module__roleRemoveIcon___S1lyQm",
  "Bx": "UserProfilePopout.module__iconSmall___S1lyQm",
  "bc": "UserProfilePopout.module__profileCustomStatus___S1lyQm",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___S1lyQm",
  "ZB": "UserProfilePopout.module__profileDisplayName___S1lyQm",
  "yn": "UserProfilePopout.module__profileDataWarning___S1lyQm",
  "gd": "UserProfilePopout.module__profilePopoutLayer___S1lyQm",
  "zF": "UserProfilePopout.module__profilePopoutCard___S1lyQm",
  "ks": "UserProfilePopout.module__profilePanelCard___S1lyQm",
};

module.exports = exports;
